/**
 * 클라이언트 텍스트 검색용 정규화 유틸.
 *
 * 한글 파일명이 NFD(분해형)로 저장되는 경우가 있다(macOS 파일명 유래 등).
 * 이 경우 검색창에 입력된 NFC(합성형) 검색어와 눈에는 같은 글자여도
 * 코드포인트가 달라 `String.prototype.includes` 비교가 실패한다.
 * 검색어·대상을 모두 NFC로 정규화한 뒤 비교해 이 불일치를 방지한다.
 */
const normalizeSearchText = (text: string): string =>
  text.normalize("NFC").toLowerCase();

/** 대상 문자열이 검색어를 포함하는지 NFC 정규화 후(대소문자 무시) 검사한다. */
export const searchTextIncludes = (target: string, keyword: string): boolean =>
  normalizeSearchText(target).includes(normalizeSearchText(keyword));

/**
 * 검색어로 목록을 거른다. 빈 검색어는 전체를 통과시킨다.
 *
 * `getHaystack` 은 항목에서 검색 대상 문자열을 뽑는다. 여러 필드를 검색 대상으로
 * 삼으려면 공백으로 이어붙여 반환한다.
 */
export const filterBySearchText = <T>(
  items: T[],
  keyword: string,
  getHaystack: (item: T) => string,
): T[] => {
  const trimmed = keyword.trim();
  if (!trimmed) return items;
  return items.filter((item) => searchTextIncludes(getHaystack(item), trimmed));
};
